"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makePrimitiveIterator = makePrimitiveIterator;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _constants = require("../constants");
var _modes = require("../primitives/modes");
var _loaderUtils = require("@loaders.gl/loader-utils");
var _marked = _regenerator.default.mark(makePrimitiveIterator);
function makePrimitiveIterator(indices) {
  var attributes,
    mode,
    start,
    end,
    info,
    i,
    _args = arguments;
  return _regenerator.default.wrap(function makePrimitiveIterator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          attributes = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          mode = _args.length > 2 ? _args[2] : undefined;
          start = _args.length > 3 && _args[3] !== undefined ? _args[3] : 0;
          end = _args.length > 4 ? _args[4] : undefined;
          if (indices) {
            indices = indices.values || indices.value || indices;
          }

          if (end === undefined) {
            end = indices ? indices.length : start;
          }

          info = {
            attributes: attributes,
            type: (0, _modes.getPrimitiveModeType)(mode),
            i1: 0,
            i2: 0,
            i3: 0
          };
          i = start;
        case 8:
          if (!(i < end)) {
            _context.next = 47;
            break;
          }
          _context.t0 = mode;
          _context.next = _context.t0 === _constants.GL.POINTS ? 12 : _context.t0 === _constants.GL.LINES ? 15 : _context.t0 === _constants.GL.LINE_STRIP ? 19 : _context.t0 === _constants.GL.LINE_LOOP ? 23 : _context.t0 === _constants.GL.TRIANGLES ? 27 : _context.t0 === _constants.GL.TRIANGLE_STRIP ? 32 : _context.t0 === _constants.GL.TRIANGLE_FAN ? 36 : 41;
          break;
        case 12:
          info.i1 = i;
          i += 1;
          return _context.abrupt("break", 42);
        case 15:
          info.i1 = i;
          info.i2 = i + 1;
          i += 2;
          return _context.abrupt("break", 42);
        case 19:
          info.i1 = i;
          info.i2 = i + 1;
          i += 1;
          return _context.abrupt("break", 42);
        case 23:
          info.i1 = i;
          info.i2 = i + 1;
          i += 1;
          return _context.abrupt("break", 42);
        case 27:
          info.i1 = i;
          info.i2 = i + 1;
          info.i3 = i + 2;
          i += 3;
          return _context.abrupt("break", 42);
        case 32:
          info.i1 = i;
          info.i2 = i + 1;
          i += 1;
          return _context.abrupt("break", 42);
        case 36:
          info.i1 = 1;
          info.i2 = i;
          info.i3 = i + 1;
          i += 1;
          return _context.abrupt("break", 42);
        case 41:
          (0, _loaderUtils.assert)(false);
        case 42:
          if (indices) {
            if ('i1' in info) {
              info.i1 = indices[info.i1];
              info.i2 = indices[info.i2];
              info.i3 = indices[info.i3];
            }
          }
          _context.next = 45;
          return info;
        case 45:
          _context.next = 8;
          break;
        case 47:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
//# sourceMappingURL=primitive-iterator.js.map